export var SegmentType;
(function (SegmentType) {
    SegmentType["line"] = "line";
    SegmentType["bezier"] = "bezier";
    SegmentType["quadratic"] = "quadratic";
    SegmentType["arc"] = "arc";
    SegmentType["ellipse"] = "ellipse";
})(SegmentType || (SegmentType = {}));
